import React from 'react';
import DownloadIcon from './DownloadIcon';
// @ts-ignore - Digital HIG components
import DHBox from "@digital-hig/mui/Box";
// @ts-ignore - Digital HIG components
import DHTypography from "@digital-hig/mui/Typography";
// @ts-ignore - Digital HIG components
import DHButton from "@digital-hig/mui/Button";

interface DownloadBoxProps {
  heading: string;
  text: string;
  buttonText: string;
  buttonLink: string;
  buttonVariant: string;
  onButtonClick: () => void;
}

const DownloadBox: React.FC<DownloadBoxProps> = ({
  heading,
  text,
  buttonText,
  buttonLink,
  buttonVariant,
  onButtonClick
}) => {
  const handleButtonClick = () => {
    onButtonClick();
    if (buttonLink && buttonLink !== '#') {
      window.open(buttonLink, '_blank');
    }
  };

  return (
    <DHBox 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '200px'
      }}
    >
      {/* Top section with content */}
      <DHBox sx={{ 
        height: '148px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}>
        <DHTypography 
          variant="headline-small"
          sx={{ 
            marginBottom: '8px',
            fontFamily: 'Artifakt Element',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '150%',
            letterSpacing: '0%'
          }}
        >
          {heading}
        </DHTypography>
        <DHTypography 
          variant="caption"
          color="ink-on-background-60"
          sx={{
            fontFamily: 'Artifakt Element',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '125%',
            letterSpacing: '0%'
          }}
        >
          {text}
        </DHTypography>
      </DHBox>
      
      {/* Divider */}
      <DHBox sx={{
        marginTop: 'auto',
        height: '1px',
        backgroundColor: '#e0e0e0',
        width: '100%'
      }} />
      
      {/* Bottom section with button */}
      <DHBox sx={{ 
        height: '60px',
        display: 'flex',
        alignItems: 'center'
      }}>
        <DHButton
          variant={buttonVariant}
          onClick={handleButtonClick}
          startIcon={<DownloadIcon color="#000000" width={20} height={20} />}
          sx={{
            fontFamily: 'Artifakt Element, sans-serif',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0%',
            alignItems: 'center',
            verticalAlign: 'middle',
            '& .MuiButton-startIcon': {
              marginRight: '8px'
            },
            '&:hover': {
              transform: 'none',
              textDecoration: 'none'
            }
          }}
        >
          {buttonText}
        </DHButton>
      </DHBox>
    </DHBox>
  );
};

export default DownloadBox;

